<template>
  <Badge
    :value="props.value"
    :severity="props.severity"
    :size="props.size"
    :dot="props.dot"
  >
    <slot></slot>
  </Badge>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import type { MOPBadgeProps } from './types'

export default defineComponent({
  name: 'MOPBadge',
  inheritAttrs: false
})
</script>

<script setup lang="ts">
import Badge from 'primevue/badge'

const props = withDefaults(defineProps<MOPBadgeProps>(), {
  value: undefined,
  severity: null,
  size: null,
})
</script>
